import GlifosDigitalArchiveViewer from 'modules/glifos-digital-archive/components/GlifosDigitalArchiveViewer/GlifosDigitalArchiveViewer';
import Alert from 'modules/website/components/Alert/Alert';
import { useVideoInfoPage } from 'modules/website/hooks/useVideoInfoPage';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import styles from './GlifosDigitalArchiveView.module.scss';
import TestFile from 'assets/files/France_Nullement_Impliquee.pdf';
import { Link, useLocation, useParams } from 'react-router-dom';
import ShareButton from 'modules/website/components/New/ShareButton/ShareButton';
import GLifosMetadata from 'modules/glifos-rich-media/components/GLifosMetadata/GLifosMetadata';
import { useDigitalArchivePage } from 'modules/website/hooks/useDigitalArchivePage';
import ApiURLs from 'services/BackendApi/BackendApiURLs';
import { Download } from 'react-bootstrap-icons';
import { ClipLoader, PulseLoader } from 'react-spinners';
import EmailSender from 'modules/glifos-rich-media/components/EmailSender/EmailSender';

export default function GlifosDigitalArchiveView(props) {
	//const { setBreadC, title } = props;
	const location = useLocation();
	const { alias, alias2, nid } = useParams();
	const [title, setTitle] = useState('');
	const [fileUrl, setFileUrl] = useState('');
	//============= Esto se debe de descomentar para cuando ya se tenga el backend listo =============
	const { isLoading, isError, payload, error } = useDigitalArchivePage({
		alias: alias ? `${alias}${alias2 ? "$$" + alias2 : ""}` : nid,
		stylesheet: 'DefaultJSON_digital_archive',
	});

	useEffect(() => {
		if (payload) {
			//Add at the end of BreadC the title of the video
			setFileUrl(ApiURLs.baseURL + '/v1/file/get/' + payload?.document?.filename);
			//console.log(payload.metadatas);
			//setTitle(payload.metadatas[0].title);

		}
	}, [payload]);

	const handleDownload = () => {
		// Reemplaza con la URL de tu archivo
		const link = document.createElement("a");
		link.href = fileUrl;
		link.download = payload?.document?.file_original_name; // Nombre del archivo a descargar
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};
	const [loading, setLoading] = useState(false);

	const downloadFile = async (fileId) => {
		try {
			setLoading(true); // Activar estado de carga

			const response = await fetch(`${ApiURLs.baseURL}/v1/file/download/${fileId}`, {
				method: "GET",
				headers: {
					Accept: "*/*",
				},
			});

			if (!response.ok) {
				throw new Error("Error al descargar el archivo");
			}

			let filename = response.headers.get("X-Filename");
			filename = filename ? decodeURIComponent(filename) : `archivo_${fileId}.bin`;

			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error("Error al descargar:", error);
		} finally {
			setLoading(false); // Desactivar estado de carga
		}
	};

	//console.log(payload);
	/* useEffect(() => {
		if(payload){
			//Add at the end of BreadC the title of the video
			const newBreadC = [...payload.breadC];
			newBreadC.push({title:title});
			setBreadC(newBreadC);
			//console.log(payload.metadatas);
			//setTitle(payload.metadatas[0].title);

		}
	}, [payload]); */
	// =================================================================================================
	//============= Esto se debe de comentar para cuando ya se tenga el backend listo =============
	/* const isLoading = false;
	const isError = false;
	const error = '';
	const payload = {
		"metadata": [
		  {
			"title": "Concordances humanitaires et génocidaires, Bernard Kouchner au Rwanda",
			"description": "La plupart des interventions de la France au Rwanda, de 1990 à 1994, ont été présentées dans les médias comme ayant un but humanitaire. Bernard Kouchner, médecin et homme politiquetrès connue, s'est trouvé à la charnière entre le domanine politico-militaire et l'humanitaire. Most of the interventions of France in Rwanda, from 1990 to 1994, have been presented in the mediaas having a humanitarian goal. Bernard Kouchner, a famous doctor and politician, is located at the center of the politico-military field and the humanitarian.",
			"date of publication": "2006-11-13",
			"author": "J. Morrel, G. Kapler",
			"type of media": "Report",
			"language": "eng",
			"repository": ""
		  }
		],
		"breadC": [
		  {
			"path": "/category/Reports",
			"title": "Reports"
		  }
		],
		"document": {
		  "filename": "fd04e16ef1e67ef2c29d8874eaad6daa"
		}
	  }; */
	// =================================================================================================
	if (isLoading) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
				<ClipLoader
					loading={isLoading}
					size={50}
					aria-label="Loading Spinner"
					data-testid="loader"
				/>
			</div>
		)
	} else if (isError && !isLoading) {
		return (
			<Alert variant='danger'>{error}</Alert>
		)
	} else if (!isError && !isLoading && payload) {
		return (
			<Container fluid>
				<Row>
					{!isLoading && !isError && payload && (
						<div className={`${styles.topPart}`}>
							<div className={`${styles.header}`}>
								<div>
									{payload?.categories[0]?.title}
								</div>
								<div>
									ISSN {payload?.metadata[0]?.issn}
								</div>
								<div>
									Volume {payload?.metadata[0]?.volume}, Number {payload?.metadata[0]?.number}
								</div>
							</div>
							<div className={`${styles.divisor}`}></div>
							<div className={`${styles.categories}`}>
								<Link to='/Categories'>Categories: </Link>
								{payload?.categories?.map((item, index) => (
									index === payload.categories.length - 1 ?
										<div key={index} className={`${styles.category}`}>
											<Link to={item.path}>{item.title}</Link>
										</div>
										:
										<>
											<div key={index} className={`${styles.category}`}>
												<Link to={item.path}>{item.title}</Link>
											</div>
											<div key={index} className={`${styles.separador}`}>
												|
											</div>
										</>
								))}
							</div>
							<div className={`${styles.title}`}>{payload?.metadata[0]?.title}</div>
							{payload?.metadata[0]?.authors.map((item, index) => (
								<div className={`${styles.author}`} key={index}>
									{item}
								</div>
							))}

							<div className='d-flex justify-content-end gap-5 mb-3 mt-5'>
								{/* <div onClick={handleDownload}>Download</div> */}
								{/* <div className={`${styles.btn}`} onClick={handleDownload}> */}
								{loading ? (
									<div className={`${styles.btnloading}`}>
										<PulseLoader
											loading={true}
											size={5}
											aria-label="Loading Spinner"
											data-testid="loader"
										/>
									</div>
								) : (

									<div className={`${styles.btn}`} onClick={() => downloadFile(payload?.document?.filename)}>
										<Download className={`${styles.icon}`} />
										Download
									</div>
								)}
								<ShareButton title={payload?.metadata[0]?.title} />
								<EmailSender titlePage={payload?.metadata[0]?.title} secondstyle={true}/>
							</div>
						</div>
					)}
				</Row>
				<Row>
					{!isLoading && !isError && payload && (
						<GlifosDigitalArchiveViewer src={ApiURLs.baseURL + '/v1/file/get/' + payload?.document?.filename} />
					)}
					{/* <GlifosDigitalArchiveViewer src={'https://api.gar.local/v1/file/get/06625ae1512578607f313477c9aecea4'} /> */}
				</Row>
				{/* <Row>
				<ShareButton document />
			</Row> */}
				<Row>
					{!isLoading && !isError && payload && (
						<>
							<Col md={12}>
								<GLifosMetadata metadata={payload.metadata} author_citation={payload.author_citation} />
							</Col>
						</>
					)}
				</Row>
				{props.children}
			</Container>
		);
	}
}
